import { IntegrationsModule } from '@core/modules/integrations'
import {
    FormField,
    TIntegration,
} from '@core/modules/integrations/integrations'
import { StyledActionButton } from '@ui/drawer/integration/integrationDetails/integrationDetails.styles'
import Form from '@ui/drawer/integration/integrationForm/components/Form'
import { FormProvider, useForm } from 'react-hook-form'
import { Wrapper } from './integrationForm.styles'
import { useDrawer } from '@/core/context/DrawerContext'

const IntegrationForm = ({
    integration,
    formStructure,
}: {
    integration: TIntegration
    formStructure: FormField[]
}) => {
    const form = useForm()
    const [loading, setLoading] = useState(false)
    const { setDrawerState } = useDrawer()
    const onSubmit = async () => {
        setLoading(true)
        await form.trigger()
        if (form.formState.isValid) {
            await IntegrationsModule.activateIntegration({
                providerId: integration.id,
                custom: form.getValues(),
            })
            setLoading(false)
            setDrawerState((prevState) => ({
                ...prevState,
                isDrawerOpen: false,
            }))
        } else {
            setLoading(false)
        }
    }

    return (
        <>
            <Wrapper>
                <FormProvider {...form}>
                    <Form formStructure={formStructure} />
                </FormProvider>
            </Wrapper>
            <StyledActionButton
                text={`Enable Integration`}
                onClick={onSubmit}
                loading={loading}
                disabled={loading}
            />
        </>
    )
}

export default IntegrationForm
